import React from 'react';

function TimeframeSelector({ options, value, onChange, className = '' }) {
  return (
    <div className={`inline-flex bg-gray-800 rounded p-1 ${className}`}>
      {options.map((opt) => {
        const active = opt.key === value;
        return (
          <button
            key={opt.key}
            onClick={() => onChange(opt.key)}
            className={`px-2 py-1 text-xs rounded transition-colors ${
              active
                ? 'bg-blue-600 text-white'
                : 'text-gray-300 hover:text-white hover:bg-gray-700'
            }`}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}

export default TimeframeSelector;
